// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const UPLOAD_ID_VERIFICATION_IFRAME_PROPS = {
  endpoint: '/v1/checkout/orders/id-validation',
  frameGap: 178,
  webSocketMessage: {
    endpoint: '/v1/checkout/orders/id-validation',
    payload: {
      orderId: getCheckoutIdFromUrl(),
    },
  },
  shouldConnectWs: true,
  listenWsEvents: true,
};

export { UPLOAD_ID_VERIFICATION_IFRAME_PROPS };
